import { defineComponent as _defineComponent } from 'vue'
import A11yDialog from "a11y-dialog";
import { onMounted, ref } from "vue";

import CloseDialogButton from "./CloseDialogButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Dialog',
  setup(__props, { expose }) {

const dialogElementRef = ref(null);

let dialog: A11yDialog | null = null;

onMounted(() => {
  const protocolDialogContainer = dialogElementRef.value;

  if (protocolDialogContainer) {
    dialog = new A11yDialog(protocolDialogContainer);
  }
});

expose({ getDialog: () => dialog });

return { __sfc: true,dialogElementRef, dialog, CloseDialogButton }
}

})